(function () {
  if (window.__riversolScrollToTarget) return;
  window.__riversolScrollToTarget = true;

  function getHeaderOffset() {
    var header = document.querySelector('sticky-header, .shopify-section-header-sticky, .header-wrapper, header');
    return header ? header.getBoundingClientRect().height : 0;
  }

  function scrollToElement(target) {
    var headerOffset = getHeaderOffset();
    var targetTop = window.pageYOffset + target.getBoundingClientRect().top - headerOffset - 8;

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth'
    });
  }

  function resolveTargetId(raw) {
    if (!raw) return '';

    var id = String(raw).trim();
    if (id.charAt(0) === '#') id = id.slice(1);

    return id;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-scroll-to-target]');
    if (!link) return;

    var id = resolveTargetId(link.getAttribute('data-scroll-to-target'));
    if (!id) return;

    var target = document.getElementById(id);
    if (!target) return;

    event.preventDefault();
    scrollToElement(target);
  });
})();
